import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { COUPON_SET_MEDIUM, COUPON_TYPES, DISPLAY_COUPON_TYPES, WEEKDAY } from 'config/CustomEnums';
import { parseCouponSetOverviewDatetime } from 'models/CouponUtil';

import BaseOverView from './BaseOverview';

import { getReadablePeriod } from 'utils/TimeFormatUtil';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';

import './CouponTemplateOverview.scss';

function CouponAdditionalInfo({ couponSet }) {
  const additionalData = couponSet?.additionalData || [];
  if (!additionalData.length) {
    return null
  }
  const additionalDataDisplay = (data) => {
    return (
      <div>
        <div>{`Title: ${data.title || '-'}`}</div>
        <div>{`Value: ${data.value || '-'}`}</div>
      </div>
    );
  };

  const filedList = additionalData.map((item, index) => {
    return [
      {
        title: `Fields #${index + 1} (optional)`,
        field: item.title,
        customRender: additionalDataDisplay(item),
      },
    ];
  });



  return (
    <div className='coupon-overview-container'>
      <div className='create-section-label-top-space'/>
      <MembershipInfoCard
        title="ADDITIONAL DATA (OPTIONAL)"
        data={additionalData}
        fields={filedList}
      />
    </div>
  )
}

function CouponTemplateOverview({ couponSet, isTicket = false }) {
  const displayCouponType = DISPLAY_COUPON_TYPES?.[couponSet?.type] || "-"

  const DISPLAY_MEDIUM_TYPES_MAP = {
    [COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE]: "Online or offline",
    [COUPON_SET_MEDIUM.ONLINE]: "Online only",
    [COUPON_SET_MEDIUM.OFFLINE]: "Offline only",
  }
  const mediumType = couponSet?.mediumType;
  const mediumTypeDisplay = DISPLAY_MEDIUM_TYPES_MAP?.[mediumType] || DISPLAY_MEDIUM_TYPES_MAP[COUPON_SET_MEDIUM.OFFLINE]

  const isOfflineOrOnline = mediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE
  const getListStrings = (list, linkPrefix = "", linkText = "View detail", getSubList=()=>{}) => {
    if (list?.length === 0) {
      return null;
    }
    return (
      <ul>
        {list?.map((item) => (
          <li>
            <div>
              {`[ID: ${item.pk}] ${item.name}`}
              {linkPrefix && <Link className="profile-section-link" to={`${linkPrefix}/${item.pk}/`}>{linkText}</Link>}
            </div>
            {getSubList(item)}
          </li>
        ))}
      </ul>
    );
  };

  const displayFields = [
    // { title: 'Type', value: displayCouponType },
    { title: 'Coupon medium', value: mediumTypeDisplay },
    { title: 'Total Stock', value: couponSet?.totalNumberOfGeneratedCoupons, },
    ...isOfflineOrOnline ? [
      { title: 'Total online coupon Stock', value: couponSet?.totalNumberOfGeneratedOnlineCoupons, },
      { title: 'Total offline coupon Stock', value: couponSet?.totalNumberOfGeneratedOfflineCoupons, }
    ] : [],
    { title: `Available ${isTicket ? 'ticket' : 'coupon'}`, value: couponSet?.stock, },
    ...isOfflineOrOnline ? [
      { title: 'Available online coupon', value: couponSet?.onlineStock, },
      { title: 'Available offline coupon', value: couponSet?.offlineStock, },
    ] : [],
    {
      title: `Linked ${isTicket ? "event" : "campaign"}`, value: getListStrings(
        couponSet?.linkedCampaigns,
        isTicket ? '/events' : '/campaigns',
        `View ${isTicket ? "event" : "campaign"}`,
        (campaign) => (
          <div>
            {getListStrings(campaign?.earningRules, '/earns', 'View earning rule')}
          </div>
        )
      ) || '-',
    },
    {
      title: 'Linked stamp campaign', value: getListStrings(couponSet?.linkedStampCampaigns, '/stamp_campaigns', 'View campaign') || '-',
    },
    {
      title: 'Linked earning rules', value: getListStrings(couponSet?.linkedEarningRules, '/earns', 'View earning rule') || '-',
    },
    {
      title: 'Blackout period (by period)', value: couponSet?.validPeriodValues?.length > 0
        ? couponSet?.validPeriodValues?.map((item) =>
          getReadablePeriod(item.startDate, item.endDate, false),
        )
        : '-',
    },
    {
      title: 'Blackout period (by weekday)', value: couponSet?.validWeekday?.length > 0
        ? couponSet?.validWeekday?.map((item) => WEEKDAY[item])
        : '-',
    },
  ].filter(item => {
    if (isTicket && [
      "Coupon medium",
      "Linked stamp campaign",
      "Linked earning rules",
    ].includes(item.title)) {
      return false;
    }
    return true;
  });

  const titleList = displayFields?.map(item=> item?.title);
  const valueList = displayFields?.map(item => item?.value);

  const generalSectionFields = [
    { title: 'Status', value: couponSet?.status, },
    { title: 'Creation time', value: couponSet?.detailDisplayCreationDate || "-", },
    { title: 'Last modified time', value: couponSet?.detailDisplayLastModifiedDate || "-", },
    { title: 'Last modified by', value: couponSet?.displayLastModifiedBy || "-", },
  ]

  const generalSectionTitleList = generalSectionFields?.map(item => item?.title);
  const generalSectionValueList = generalSectionFields?.map(item => item?.value);
  return (
    <>
      <BaseOverView title={"INFORMATION"} itemTitleList={titleList} itemValueList={valueList} />
      <CouponAdditionalInfo couponSet={couponSet} />
      <BaseOverView title={"GENERAL"} itemTitleList={generalSectionTitleList} itemValueList={generalSectionValueList} />
    </>
    );
}

export default CouponTemplateOverview;
